"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _CustomQuantityEntry = _interopRequireDefault(require("./CustomQuantityEntry"));

var _QuantityCell = _interopRequireDefault(require("./QuantityCell"));

var QuantityTable =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(QuantityTable, _Component);

  function QuantityTable() {
    (0, _classCallCheck2.default)(this, QuantityTable);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(QuantityTable).apply(this, arguments));
  }

  (0, _createClass2.default)(QuantityTable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          quantities = _this$props.quantities,
          addQuantities = _this$props.addQuantities,
          resetQuantities = _this$props.resetQuantities,
          deleteQuantity = _this$props.deleteQuantity,
          addedQuantities = _this$props.addedQuantities,
          resetting = _this$props.resetting,
          deletedIndex = _this$props.deletedIndex,
          width = _this$props.width,
          onShippingSubmit = _this$props.onShippingSubmit,
          shipmentConfiguration = _this$props.shipmentConfiguration;
      return _react.default.createElement("table", {
        className: "table table-striped pricing-table",
        style: {
          width: width
        }
      }, _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement(_CustomQuantityEntry.default, {
        addQuantities: addQuantities,
        resetQuantities: resetQuantities,
        onShippingSubmit: onShippingSubmit,
        shipmentConfiguration: shipmentConfiguration
      }))), _react.default.createElement("tbody", null, quantities.map(function (qty, qtyIdx) {
        var rowClass = 'pricing-row';

        if (addedQuantities && addedQuantities.includes(qty)) {
          rowClass += ' added-item';
        } else if (resetting || deletedIndex === qtyIdx) {
          rowClass += ' deleted-item';
        }

        return _react.default.createElement("tr", {
          key: qty,
          className: rowClass
        }, _react.default.createElement(_QuantityCell.default, {
          quantity: qty,
          index: qtyIdx,
          deleteQuantity: deleteQuantity
        }));
      })));
    }
  }]);
  return QuantityTable;
}(_react.Component);

exports.default = QuantityTable;
QuantityTable.defaultProps = {
  width: '110px'
};